import { AGENTS } from './constants';
import { de } from './format';
export function doses(phV, clV, g) {
    const out = [];
    const build = (key, deviation, dose, effect, unitText) => {
        if (!(deviation > 0) || !(dose > 0) || !(effect > 0))
            return;
        const n = Math.max(1, Math.ceil(deviation / effect));
        const grams = Math.round(n * dose);
        const a = AGENTS[key];
        out.push({
            agentKey: key,
            agent: a.label,
            color: a.color,
            badgeBg: a.badge,
            grams,
            headline: `${grams} g ${a.label}`,
            detail: `${n} ${n === 1 ? 'Dosis' : 'Dosen'} à ${dose} g · ${unitText}`
        });
    };
    const phTargetVal = (g.phMin + g.phMax) / 2;
    const clTargetVal = (g.clMin + g.clMax) / 2;
    if (phV !== null && phV > g.phMax) {
        build('phMinus', phV - phTargetVal, g.phMinusDose, g.phMinusEffect, `pH auf ${de(phTargetVal, 1)} senken`);
    }
    if (phV !== null && phV < g.phMin) {
        build('phPlus', phTargetVal - phV, g.phPlusDose, g.phPlusEffect, `pH auf ${de(phTargetVal, 1)} anheben`);
    }
    if (clV !== null && clV < g.clMin) {
        build('chlor', clTargetVal - clV, g.clDose, g.clEffect, `Chlor auf ${de(clTargetVal, 2)} mg/l bringen`);
    }
    return out;
}
export function doseStepFor(agent, g) {
    return agent === 'phMinus' ? g.phMinusDose : agent === 'phPlus' ? g.phPlusDose : g.clDose;
}
export function doseHint(agent, g) {
    if (agent === 'phMinus')
        return `${g.phMinusDose} g senken den pH-Wert um ${de(g.phMinusEffect, 1)}.`;
    if (agent === 'phPlus')
        return `${g.phPlusDose} g heben den pH-Wert um ${de(g.phPlusEffect, 1)}.`;
    return `${g.clDose} g erhöhen den Chlorwert um ${de(g.clEffect, 2)} mg/l.`;
}
